/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exceptions_EmptyInputs */



/**
* | output |
* | --- |
* | "Nothing switched off. Wundo follows your choice above exactly." |
*
* @param {Meetings_Exceptions_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exceptions_empty = /** @type {((inputs?: Meetings_Exceptions_EmptyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exceptions_EmptyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Niets uitgeschakeld. Wundo volgt precies je keuze hierboven.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rien de désactivé. Wundo suit exactement votre choix ci-dessus.")
	return /** @type {LocalizedString} */ ("Nothing switched off. Wundo follows your choice above exactly.")
});